import React from "react";
import { formatDistanceToNow } from "date-fns";

const Reviews = ({ player }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <h3
        style={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#50868f",
          marginBottom: "20px",
          paddingBottom: "10px",
          borderBottom: "2px solid #50868f",
        }}
      >
        {player.name}'s Reviews
      </h3>

      {player.reviews.length === 0 ? (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#666", fontStyle: "italic" }}>
            No reviews yet for this player
          </p>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {player.reviews.map((review) => (
            <div
              key={review.review_id}
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div style={{ marginBottom: "16px" }}>
                <p
                  style={{
                    color: "#333",
                    fontSize: "18px",
                    fontWeight: "500",
                    marginBottom: "8px",
                  }}
                >
                  "{review.review_text}"
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#666",
                  }}
                >
                  {/* {formatDistanceToNow(new Date(review.reviewed_at), { addSuffix: true })} */}
                  {formatTime(review.reviewed_at)}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Reviews;
